/**
 * Domain Ports - DI Symbols
 * 
 * Clean separation of DI symbols from interface types.
 * Following the systematic pattern to prevent export issues.
 */

// Package Mapping Repository Symbol
export const IPackageMappingRepositorySymbol = Symbol('IPackageMappingRepository');

// Meta Model Analysis Port Symbol
export const IMetaModelAnalysisPortSymbol = Symbol.for('IMetaModelAnalysisPort');